module.exports = __webpack_public_path__ + "assets/img/teacher (47).b48b3996.png";